
import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.GR001.error_id: {
            return (
                <>
                    <ResultText>Georeferencing of the following {row?.data?.length} cross sections are missing:</ResultText>
                    <ResultText><CheckCSName csNameList={row.data.map(x => x.cross_section)} /></ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const B9 = {
    RenderDescription,
}